<script setup lang="ts">
type Props = {
  data: Record<string, unknown>
  theme: string | null | undefined
}

// SectionsText props
const _props = defineProps<Props>()
provide('showMediaCaption', true)
</script>

<template>
  <div class="px-bleed relative w-full overflow-clip">
    <div class="grid gap-5 md:gap-10" :class="{ 'border-t border-(--theme-fg)/15': data.title }">
      <h2 v-if="data.title" class="my-8 text-sm font-bold uppercase">{{ data.title }}</h2>
      <p v-if="data.text" class="font-display text-xl tracking-tighter text-balance lg:text-2xl">
        {{ data.text }}
      </p>
      <div v-if="data.content" class="lg:w-cols-5 lg:ml-push-6 mt-1.35 w-full">
        <ElementsPortableTextWrapper :content="data.content" />
      </div>
    </div>
  </div>
</template>
